(ns ui.gallery.link
  "The URL of the gallery page (`ui.gallery.page`). Every link to the
   gallery goes through `gallery-href`, and the `/#/gallery` hash route
   of the former Reagent gallery redirects to it (see
   `storrito.web.index/legacy-hash-redirect-js`), so bookmarks and
   older links land on the same page as the sidebar.")

(defn gallery-href
  "The URL of the gallery, or of its folder with the `folder-uuid`."
  ([]
   (gallery-href nil))
  ([folder-uuid]
   (str "/ui/gallery"
        (when folder-uuid
          (str "?folder=" folder-uuid)))))
